var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6682_176488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4984 0.5H24.2109V4.92969H28.4984V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5727 0.5H18.2852V4.92969H22.5727V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2109 6.57031V6.8875C24.2109 8.06957 25.1726 9.03125 26.3547 9.03125C27.5368 9.03125 28.4984 8.06957 28.4984 6.8875V6.57031H24.2109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7172 0.5H6.42969V4.92969H10.7172V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3984 18.0547H4.60156V24.3984H24.3984V18.0547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3562 10.6718C25.1564 10.6718 24.086 10.1099 23.3922 9.23608C22.6984 10.1099 21.628 10.6718 20.4281 10.6718C19.2283 10.6718 18.1579 10.1099 17.4641 9.23608C16.7702 10.1099 15.6998 10.6718 14.5 10.6718C13.3002 10.6718 12.2298 10.1099 11.5359 9.23608C10.8421 10.1099 9.77172 10.6718 8.57188 10.6718C7.37203 10.6718 6.30163 10.1099 5.60781 9.23608C4.91399 10.1099 3.84359 10.6718 2.64375 10.6718C1.84832 10.6718 1.10988 10.4246 0.5 10.0037V28.4999H28.5V10.0037C27.8901 10.4246 27.1516 10.6718 26.3562 10.6718ZM26.0391 26.039H2.96094V13.1327H26.0391V26.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42969 6.57031V6.8875C6.42969 8.06957 7.39137 9.03125 8.57344 9.03125C9.75551 9.03125 10.7172 8.06957 10.7172 6.8875V6.57031H6.42969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3555 6.57031V6.8875C12.3555 8.06957 13.3171 9.03125 14.4992 9.03125C15.6813 9.03125 16.643 8.06957 16.643 6.8875V6.57031H12.3555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2852 6.57031V6.8875C18.2852 8.06957 19.2468 9.03125 20.4289 9.03125C21.6109 9.03125 22.5726 8.06957 22.5726 6.8875V6.57031H18.2852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3984 14.7734H22.7578V16.4141H24.3984V14.7734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.643 0.5H12.3555V4.92969H16.643V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7875 0.5H0.5V4.92969H4.7875V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1172 14.7734H4.60156V16.4141H21.1172V14.7734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.57031V6.8875C0.5 8.06957 1.46168 9.03125 2.64375 9.03125C3.82582 9.03125 4.7875 8.06957 4.7875 6.8875V6.57031H0.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6682_176488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.38bca370c32256cafa6de1785cb98837.svg";
export { ForwardRef as ReactComponent };